import React from "react";
import { SonicEventData } from "../../../../common/classes/SonicEvent";
import LoadingSpinner from "../../../../common/LoadingSpinner";
import ActionBtn from "../../../../common/management/ActionBtn";
import Status from "../../../../common/management/detail/Status";
import NotificationModal from "../../../../common/settings-modal/NotificationModal";
import { checkForJikeiRoles } from "../../../../utils/GeneralUtils";
import {
  RequestState,
  genNotificationColor,
  genNotificationMessage,
} from "../../../../utils/RequestState";
import styles from "../../../management/db-list/detail/DatabaseDetail.module.scss";
import SelenaA from "../../../../assets/img/service/selena-a.webp";
import SonicLink from "../../../../common/routing/SonicLink";

type Props = {
  children: JSX.Element;
  event: SonicEventData;
  owner: { email: string; roles: string[]; full_name?: string };
  isLoading: boolean;
  requestState: RequestState;
  isSelect: boolean;

  selectStatus?: string;
  setSelectStatus: (value: string, name: string) => void;
  handleUpdate: () => void;

  showStatusMenu: boolean;
  handleStatusMenu: () => void;

  error: boolean;
};

const EventDetail: React.FC<Props> = ({
  children,
  event,
  owner,
  isLoading,
  requestState,
  selectStatus,
  isSelect,
  setSelectStatus,
  handleUpdate,
  showStatusMenu,
  handleStatusMenu,
  error,
}) => {
  return (
    <div className={styles["f-databaseDetail"]}>
      {isLoading || !event || !owner ? (
        <LoadingSpinner space={1} admin_page={true} />
      ) : (
        <>
          <h1 className={styles["f-databaseDetail__title"]}>イベント詳細</h1>
          <div className={styles["f-databaseDetail__inner"]}>
            <div className={styles["f-databaseDetail__head"]}>
              <Status
                isVisibilityStatus={true}
                status={event.status}
                selectStatus={selectStatus}
                showStatusMenu={showStatusMenu}
                handleStatusMenu={handleStatusMenu}
                setSelectStatus={setSelectStatus}
              />
              <div className={styles["f-databaseDetail__user"]}>
                <div className={styles["f-databaseDetail__user-head"]}>
                  <h2 className={styles["f-databaseDetail__user-title"]}>
                    ユーザー情報
                  </h2>
                  <SonicLink
                    to={
                      isSelect
                        ? `/admin/member/${event.owner}`
                        : checkForJikeiRoles(owner.roles, true)
                        ? `/jikei/manager/${event.owner}`
                        : `/jikei/student/${event.owner}`
                    }
                  >
                    ユーザー詳細
                  </SonicLink>
                </div>
                <div className={styles["f-databaseDetail__user-info"]}>
                  <div>
                    <p>ユーザー名</p>
                    <span>
                      {!isSelect && owner.full_name
                        ? owner.full_name
                        : event.owner_name}
                    </span>
                  </div>
                  <div>
                    <p>メールアドレス</p>
                    <span>{owner.email}</span>
                  </div>
                </div>
              </div>
            </div>

            {children}

            {error ? (
              <div className={styles["f-databaseDetail__error"]}>
                必須項目が未入力、または入力内容に誤りがあります
              </div>
            ) : null}

            <div className={styles["f-databaseDetail__bottom"]}>
              <ActionBtn
                label="保存"
                onClick={() => handleUpdate()}
                colorReversal={true}
              />
            </div>
            <div className={styles["f-databaseDetail__btn"]}>
              <ActionBtn
                label="保存"
                onClick={() => handleUpdate()}
                colorReversal={true}
              />
            </div>
          </div>
          {/* {isSelect && (
            <RelatedContentSetting
              recommends={recommendEvents}
              recommendOptions={
                events.length > 0 ? eventsToRecommendOptions(events) : []
              }
              addHandler={handleAddRecommend}
              removeHandler={handleRemoveRecommend}
              parentName={event.name}
              parentGames={event.game}
            />
          )} */}
        </>
      )}
      {requestState !== RequestState.Waiting ? (
        <NotificationModal
          color={genNotificationColor(requestState)}
          message={genNotificationMessage(requestState)}
          img_src={requestState === RequestState.Success ? SelenaA : undefined}
        />
      ) : null}
    </div>
  );
};

export default EventDetail;
